export const defaultLocale = 'en-US';

export const supportedLocales = ['en-US', 'de-DE'];
